import React from "react";
import { motion } from "framer-motion";
import { Heart, Info } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";

const DonationSection = () => {
  return (
    <section
      id="dhurime"
      className="py-16 md:py-24 bg-muted"
      data-testid="donation-section"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div
            className="relative rounded-3xl overflow-hidden shadow-2xl"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1581630204750-1e29d1a5ecf5?crop=entropy&cs=srgb&fm=jpg&q=85)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary-700/90" />

            <div className="relative z-10 p-8 md:p-12 text-white text-center">
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <Heart className="w-10 h-10" fill="white" />
              </motion.div>

              <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6">
                Mbështes Xhaminë Tonë
              </h2>

              <p className="text-xl leading-relaxed mb-4 text-white/90">
                Sadaka juaj ndihmon në mirembajtjen e xhamisë, organizimin e
                aktiviteteve fetare, dhe mbështetjen e familjevve në nevojë në
                komunitetin tonë.
              </p>

              <p className="text-lg mb-8 text-accent-100 font-semibold">
                "All-llahu do të shumëzojë shpërblimin e atij që jep sadaka" -
                Kur'ani
              </p>

              <Dialog>
                <DialogTrigger asChild>
                  <Button
                    size="lg"
                    className="bg-accent hover:bg-accent-700 text-white font-bold text-lg px-8 py-6 rounded-full shadow-2xl hover:shadow-accent/50 transition-all hover:scale-105"
                    data-testid="donation-info-button"
                  >
                    <Heart className="w-5 h-5 mr-2" />
                    Bëj Dhurim
                  </Button>
                </DialogTrigger>
                <DialogContent
                  className="max-w-lg"
                  data-testid="donation-info-modal"
                >
                  <DialogHeader>
                    <DialogTitle className="text-2xl font-heading">
                      Informacion për Dhurime
                    </DialogTitle>
                  </DialogHeader>
                  <div className="space-y-6 pt-4">
                    <div className="bg-primary/5 rounded-xl p-6">
                      <div className="flex items-start gap-3 mb-4">
                        <Info className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                        <div>
                          <h3 className="font-heading font-semibold text-lg mb-2">
                            Si të kontribuoni
                          </h3>
                          <p className="text-muted-foreground leading-relaxed">
                            Dhurimet tuaja shkon direkt për mirembajtjen e
                            xhamisë dhe aktivitetet e komunitetit.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <h4 className="font-semibold mb-2 text-foreground">
                          Në Person
                        </h4>
                        <p className="text-muted-foreground text-sm leading-relaxed">
                          Mund të kontribuoni direkt gjatë vizitës në xhami.
                          Imami dhe stafi janë të disponueshëm pas çdo namazi
                          për të marrë dhurimet tuaja.
                        </p>
                      </div>
                    </div>

                    <div className="bg-accent/10 rounded-lg p-4 border-l-4 border-accent">
                      <p className="text-sm text-foreground">
                        <span className="font-semibold">Shënim:</span> Të gjitha
                        dhurimet janë vullnetare dhe përdoren vetëm për qëllime
                        fetare dhe komunitare.
                      </p>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DonationSection;
